import { render, staticRenderFns } from "./HoverThumb.vue?vue&type=template&id=28f40050&scoped=true"
import script from "./HoverThumb.vue?vue&type=script&lang=js"
export * from "./HoverThumb.vue?vue&type=script&lang=js"
import style0 from "./HoverThumb.vue?vue&type=style&index=0&id=28f40050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f40050",
  null
  
)

export default component.exports